__turbopack_context__.v({
  "groupWrap": "_0Xb8Dq_groupWrap",
  "highlightedComment": "_0Xb8Dq_highlightedComment",
  "repliesIndicator": "_0Xb8Dq_repliesIndicator",
  "replyInset": "_0Xb8Dq_replyInset",
  "rootCommentReplyInset": "_0Xb8Dq_rootCommentReplyInset",
});
